import React from 'react';

export const PersonalDemo = () => {
    return (
        <div className="flex align-items-center py-5 px-3">
            <i className="pi pi-fw pi-user mr-2 text-2xl" />
            <p className="m-0 text-lg">Personal Component Content via Child Route</p>
        </div>
    )
}
